/** @prettier */
import { connect } from 'react-redux';

import {
  setCancelAllWarning,
  setSubmitAllWarning,
} from '@xanadu/ui-shared/modules/betslip/actions';
import { removeSelectionFromMultipleByCids } from '@xanadu/ui-shared/modules/multiples/actions';
import {
  removeOffersByCids,
  reviewUnsubmittedOffer,
  submitOffers,
  updateUnsubmittedOfferByCid,
} from '@xanadu/ui-shared/modules/unsubmittedOffers/actions';
import { isBonusAvailable } from '@xanadu/ui-shared/modules/unsubmittedOffers/selectors';

import Offers from '../../../components/betslip/Offers';

const mapDispatchToProps = {
  onUpdateOffers: updateUnsubmittedOfferByCid,
  onRemoveOffers: removeOffersByCids,
  onRemoveMultipleSelections: removeSelectionFromMultipleByCids,
  onSubmitOffers: submitOffers,
  onReviewOffer: reviewUnsubmittedOffer,
  setSubmitAllWarning,
  setCancelAllWarning,
};

const mapStateToProps = (state) => ({
  bonusAvailable: isBonusAvailable(state),
  showMarketingConsentReminder: state.getIn(['user', 'showMarketingConsentReminder']),
  proofOfAddressStatus: state.getIn(['user', 'proofOfAddressStatus']),
  proofOfIdentityStatus: state.getIn(['user', 'proofOfIdentityStatus']),
  eddStatus: state.getIn(['user', 'eddStatus']),
  unsubmittedOffers: state.get('unsubmittedOffers'),
  currency: state.getIn(['user', 'currency']),
  oddsType: state.getIn(['user', 'oddsType']),
  bonusBalance: state.getIn(['user', 'balance', 'bonusFreeFunds']),
  isLoggedIn: state.getIn(['user', 'isLoggedIn']),
  showBetConfirmation: state.getIn(['user', 'showBetConfirmation']),
});

export default connect(mapStateToProps, mapDispatchToProps)(Offers);
